import { useSetAtom } from "jotai";
import { setSettingsModalGroupAtom } from "atoms/modalAtom/modalAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { MoveGroup, SettingsButton, DeleteButton } from "./index";

export const ProductsGroupFooter = (): JSX.Element => {
  const setSettingsModalGroup = useSetAtom(setSettingsModalGroupAtom);

  return (
    <>
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row justify-between items-center">
          <Button onClick={() => setSettingsModalGroup(false)} icon="plus" />
          <HorizontalSpace size={11} />
          <MoveGroup />
        </div>
        <div className="flex flex-row justify-between items-center">
          <DeleteButton />
          <HorizontalSpace size={11} />
          <SettingsButton />
        </div>
      </div>
    </>
  );
};
